import React from "react";
import { Link } from "react-router-dom";
import { Package } from "lucide-react";

export default function ProductCard({ product }) {
  const inStock = product.stock > 0;
  return (
    <Link
      to={`/product/${product.id}`}
      data-testid={`product-card-${product.sku}`}
      className="group bg-white border border-zinc-900 flex flex-col hover:bg-zinc-50 transition"
    >
      <div className="relative aspect-[4/3] overflow-hidden border-b border-zinc-900 bg-zinc-100">
        <img
          src={product.image}
          alt={product.name}
          className="w-full h-full object-cover group-hover:scale-105 transition duration-500"
          loading="lazy"
        />
        <div className="absolute top-2 left-2 tag bg-white px-1.5 py-0.5 border border-zinc-900">
          {product.sku}
        </div>
        {!inStock && (
          <div className="absolute inset-0 bg-zinc-900/80 flex items-center justify-center">
            <span className="font-display text-white font-black text-lg tracking-widest">
              OUT OF STOCK
            </span>
          </div>
        )}
      </div>
      <div className="p-4 flex-1 flex flex-col">
        <h3 className="font-display font-bold text-base leading-tight tracking-tight line-clamp-2 min-h-[40px]">
          {product.name}
        </h3>
        <div className="mt-3 flex items-baseline justify-between border-t border-dashed border-zinc-300 pt-3">
          <div>
            <div className="tag mb-1">Price / {product.unit}</div>
            <div className="font-mono-data font-bold text-xl">
              ₹{product.price.toFixed(2)}
            </div>
          </div>
          <div className="text-right">
            <div className="tag mb-1">In stock</div>
            <div
              className={`font-mono-data text-sm font-medium ${
                inStock ? "text-green-700" : "text-zinc-400"
              }`}
            >
              {product.stock.toLocaleString()} {product.unit}
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
}
